import { useEffect, useState } from 'react';
import { projectsApi } from './useProjects';

/** Deterministic hue from the project id so placeholders are stable + distinct. */
function hue(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) % 360;
  return h;
}

export function ProjectCover({ projectId, title, coverUpdatedAt }: { projectId: string; title: string; coverUpdatedAt?: number }): JSX.Element {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    if (coverUpdatedAt) {
      void projectsApi.getCover(projectId).then((d) => { if (alive) setSrc(d); }).catch(() => { if (alive) setSrc(null); });
    } else { setSrc(null); }
    return () => { alive = false; };
  }, [projectId, coverUpdatedAt]);

  if (src) {
    return <img src={src} alt={title} className="h-full w-full object-cover" />;
  }
  const h = hue(projectId);
  return (
    <div
      className="grid h-full w-full place-items-center text-2xl font-semibold text-white"
      style={{ background: `linear-gradient(135deg, hsl(${h} 60% 45%), hsl(${(h + 40) % 360} 60% 35%))` }}
    >
      {(title.trim()[0] ?? '?').toUpperCase()}
    </div>
  );
}
